<template>
  <div class="legend">
    <span>* {{ translations.Available }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LegendPort',
  computed: {
    ...mapState(['translations'])
  }
}
</script>

<style>
.legend {
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: 1.5rem;
  margin-left: 0.5rem;
  letter-spacing: 0.025em;
}
</style>
